import { Grid, useTheme } from '@material-ui/core';
import { ColoredImageIcon, DocumentFileIcon, MicrophoneIcon, VideoIcon } from '@room-match/shared-ui-components';
import AsyncMediaGallery from 'components/AsyncMediaGallery/AsyncMediaGallery';
import React, { Fragment, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import { useMediaShareableProfileFormat } from 'shared/hooks/useMediaShareableProfileFormat';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import IMedia from 'shared/interfaces/IMedia';
import CommonHeader, { HeaderButton } from '../CommonHeader';
import AudioItem from '../Items/AudioItem';
import ImageItem from '../Items/ImageItem';
import VideoBinItem from '../Items/VideoItem';
import useImagesHelper from '../useImagesHelper';
import {
  BorderedCont,
  Content,
  Foot,
  Head,
  Info,
  InfoItem,
  MainCont,
  NoMediaCont,
  StorageBar,
  VideoContentContainer,
} from './Dashboard.style';
import DropZone from './DropZone/DropZone';
import RenderEditButton2 from './RenderEditButton';
import MediaGallery from 'remote/MediaGallery';
import { CustomTypography } from 'shared/elements/CustomTypography';
interface Props {
  images: IMedia[];
  videos: IMedia[];
  audios: IMedia[];
  documents: IMedia[];
  refetchMediaList?: any;
  onDropImages: (images: File[]) => void;
  onClickEditImage: (images: IMedia[]) => void;
}

const UPLOAD_LIMIT_SIZE_MB = 10000;

const Dashboard: React.FC<Props> = ({ images, videos, audios, documents, onDropImages, onClickEditImage }) => {
  const theme = useTheme();
  const { fetchingImageUrlToFile } = useImagesHelper();
  const [showImageModal, setShowImageModal] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const [used, setused] = useState(0);
  const { width } = useWindowDimensions();
  const ICON_SIZE = width < 960 ? 30 : 40;
  const history = useHistory();
  const { mappedData } = useMediaShareableProfileFormat(images, {
    length: 10,
  });

  const viewAll = (location: string) => history.push(`${ROUTES.TALENT.MEDIA}/${location}`);
  const renderPhotos = () => {
    const prepareImages = images.map((image: IMedia, idx: number) => {
      return {
        id: image.id,
        src:
          image.attributes.cropped_attachment_url ||
          image.attributes.modified_attachment_url ||
          image.attributes.attachment_url,
        height: image.attributes.file_height,
        width: image.attributes.file_width,
        idx: idx + 1,
      };
    });
    return prepareImages.slice(0, 10);
  };
  const renderThumnails = () => {
    const prepareImages = images.map((image: IMedia, idx: number) => {
      return {
        id: image.id,
        src:
          image.attributes.modified_attachment_url ||
          image.attributes.cropped_attachment_url ||
          image.attributes.attachment_url,
        height: image.attributes.file_height,
        width: image.attributes.file_width,
        idx: idx + 1,
      };
    });
    return prepareImages.slice(0, 10);
  };
  const renderedImages = renderPhotos();
  const renderedThumbnails = renderThumnails();

  useEffect(() => {
    let totalMB = 0;
    images.map((i) => (totalMB = totalMB + i.attributes.file_size / 1000000));
    videos.map((i) => (totalMB = totalMB + i.attributes.file_size / 1000000));
    audios.map((i) => (totalMB = totalMB + i.attributes.file_size / 1000000));
    documents.map((i) => (totalMB = totalMB + i.attributes.file_size / 1000000));
    setused(Math.floor(totalMB * 100) / 100);
  }, [images, videos, audios, documents]);

  const ContenAction = ({ action }: { action: 'images' | 'videos' | 'audios' | 'documents' }) => {
    return <HeaderButton onClick={() => viewAll(action)}> VIEW ALL</HeaderButton>;
  };

  return (
    <MainCont container spacing={2}>
      <Grid item xs={12} lg={7}>
        <BorderedCont>
          <CommonHeader
            icon={<ColoredImageIcon style={{ width: ICON_SIZE, height: ICON_SIZE, alignSelf: 'center' }} />}
            title="Images"
            subtitle={`${
              images.length > 10 ? `Showing 10 of ${images.length} images` : `${images.length} total images`
            }`}
            contentAction={<ContenAction action="images" />}
          />
          <Content>
            {images?.length ? (
              images.slice(0, 10).map((m, key) => (
                <ImageItem
                  key={m.attributes.modified_attachment_url}
                  item={m}
                  onClick={() => {
                    setImageIndex(key);
                    setShowImageModal(true);
                  }}
                  renderElement={
                    // This is from shared component from project level
                    // <RenderEditButton showLoader={fetchingImageUrlToFile} onClickEdit={() => onClickEditImage([m])} />

                    // This is from local folder
                    <RenderEditButton2 showLoader={fetchingImageUrlToFile} onClickEdit={() => onClickEditImage([m])} />
                  }
                />
              ))
            ) : (
              <NoMediaCont>
                <CustomTypography style={{ marginTop: 50 }}>No Media Available</CustomTypography>
              </NoMediaCont>
            )}
          </Content>
        </BorderedCont>
        <BorderedCont>
          <CommonHeader
            icon={<VideoIcon style={{ width: ICON_SIZE, height: ICON_SIZE, alignSelf: 'center' }} />}
            title="Videos"
            subtitle={`${videos.length > 6 ? `Showing 6 of ${videos.length} videos` : `${videos.length} total videos`}`}
            contentAction={<ContenAction action="videos" />}
          />
          {videos?.length ? (
            <VideoContentContainer column={3}>
              {videos.slice(0, 6).map((m) => (
                <VideoBinItem key={m.id} item={m} trimmable />
              ))}
            </VideoContentContainer>
          ) : (
            <NoMediaCont>
              <CustomTypography style={{ marginTop: 50 }}>No Media Available</CustomTypography>
            </NoMediaCont>
          )}
        </BorderedCont>
        <BorderedCont>
          <CommonHeader
            icon={<MicrophoneIcon style={{ width: ICON_SIZE, height: ICON_SIZE, alignSelf: 'center' }} />}
            title="Audio"
            subtitle={`${audios.length > 6 ? `Showing 6 of ${audios.length} audio` : `${audios.length} total audio`}`}
            contentAction={<ContenAction action="audios" />}
          />
          <Content style={{ justifyContent: 'none' }}>
            {audios?.length ? (
              audios.slice(0, 6).map((m) => <AudioItem key={m.id} item={m} />)
            ) : (
              <NoMediaCont>
                <CustomTypography style={{ marginTop: 50 }}>No Media Available</CustomTypography>
              </NoMediaCont>
            )}
          </Content>
        </BorderedCont>
        <BorderedCont>
          <CommonHeader
            icon={<DocumentFileIcon className="documentIcon" style={{ height: 40, width: 38 }} />}
            title="Documents"
            subtitle={`${
              documents.length > 6 ? `Showing 6 of ${documents.length} files` : `${documents.length} total files`
            }`}
            contentAction={<ContenAction action="documents" />}
          />
          <Content style={{ justifyContent: 'none' }}>
            {documents?.length ? (
              documents.slice(0, 6).map((m) => <AudioItem key={m.id} item={m} file />)
            ) : (
              <NoMediaCont>
                <CustomTypography style={{ marginTop: 50 }}>No Media Available</CustomTypography>
              </NoMediaCont>
            )}
          </Content>
        </BorderedCont>
      </Grid>
      <Grid item xs={12} lg={5}>
        <BorderedCont padding={15}>
          <Head>
            <CustomTypography fontSize={20} style={{ fontSize: 20 }}>
              Allowance
            </CustomTypography>
            <CustomTypography fontSize={18} style={{ marginLeft: 'auto' }}>
              UNLIMITED
            </CustomTypography>
          </Head>
          <Info>
            <InfoItem>
              <ColoredImageIcon style={{ width: 20, height: 20, marginRight: 10, alignSelf: 'center' }} />
              <CustomTypography fontSize={16}>Images</CustomTypography>
              <CustomTypography fontSize={16} style={{ marginLeft: 'auto' }}>
                {images.length}
              </CustomTypography>
            </InfoItem>
            <InfoItem>
              <VideoIcon style={{ width: 20, height: 20, marginRight: 10, alignSelf: 'center' }} />
              <CustomTypography fontSize={16}>Videos</CustomTypography>
              <CustomTypography fontSize={16} style={{ marginLeft: 'auto' }}>
                {videos.length}
              </CustomTypography>
            </InfoItem>
            <InfoItem>
              <MicrophoneIcon style={{ width: 20, height: 20, marginRight: 10, alignSelf: 'center' }} />
              <CustomTypography fontSize={16}>Audio</CustomTypography>
              <CustomTypography fontSize={16} style={{ marginLeft: 'auto' }}>
                {audios.length}
              </CustomTypography>
            </InfoItem>
            <InfoItem>
              <DocumentFileIcon className="documentIcon" style={{ height: 20, marginRight: 10, width: 18 }} />
              <CustomTypography fontSize={16}>Documents</CustomTypography>
              <CustomTypography fontSize={16} style={{ marginLeft: 'auto' }}>
                {documents.length}
              </CustomTypography>
            </InfoItem>
          </Info>
          <Head>
            <CustomTypography fontSize={20}>Storage</CustomTypography>
          </Head>
          <StorageBar variant="determinate" value={(used / UPLOAD_LIMIT_SIZE_MB) * 100} />
          <Foot>
            <CustomTypography fontSize={width < 960 ? 14 : 16}>{used} MB Used</CustomTypography>
            <CustomTypography fontSize={width < 960 ? 14 : 16} style={{ marginLeft: 'auto' }}>
              UNLIMITED
            </CustomTypography>
          </Foot>
        </BorderedCont>
        <DropZone
          limitReached={used > UPLOAD_LIMIT_SIZE_MB}
          limit={UPLOAD_LIMIT_SIZE_MB - used}
          onDropImages={onDropImages}
        />
      </Grid>
      {/* <ImageGallery
        fullScreen={width < 960}
        current={imageIndex}
        images={renderedImages}
        thumbnails={renderedThumbnails}
        open={showImageModal}
        onClose={() => setShowImageModal(false)}
      /> */}
      {showImageModal ? (
        <AsyncMediaGallery
          data={mappedData || []}
          selectedIndex={imageIndex}
          type={'image'}
          openGallery={showImageModal}
          handleOpenGallery={() => setShowImageModal(false)}
          sharedTheme={theme.palette.type}
        />
      ) : (
        <Fragment />
      )}
    </MainCont>
  );
};

export default Dashboard;
